import { render, staticRenderFns } from "./LoginBg.vue?vue&type=template&id=9ba90fae&scoped=true&"
import script from "./LoginBg.vue?vue&type=script&lang=js&"
export * from "./LoginBg.vue?vue&type=script&lang=js&"
import style0 from "./LoginBg.vue?vue&type=style&index=0&id=9ba90fae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba90fae",
  null
  
)

export default component.exports